export class CookieConsent{

  cookieConsentChoice: boolean = false;
  cookieAll: boolean = false;
  cookieTracking: boolean = false;
  cookieThirdParty: boolean = false;

}
